import React from "react";

import {
  Text,
  Box,
  HStack,
} from "@whoosh/design-system/src/components/primitive";
import { Theme } from "@whoosh/design-system/src/theme/restyle/theme";

type QueueSlotFooterProps = {
  hasAvailableSlots: boolean;
  badgeText?: string;
  ctaText?: string;
  badgeBackground: keyof Theme["colors"];
  badgeTextColor: keyof Theme["colors"];
};

export const QueueSlotFooter = ({
  hasAvailableSlots,
  badgeText,
  ctaText,
  badgeBackground,
  badgeTextColor,
}: QueueSlotFooterProps) => {
  return (
    <HStack
      justifyContent="space-between"
      pt={hasAvailableSlots && badgeText ? 4 : 0}
    >
      {hasAvailableSlots && badgeText ? (
        <Box backgroundColor={badgeBackground} px={2} py={1} borderRadius="2">
          <Text
            maxFontSizeMultiplier={2}
            color={badgeTextColor}
            variant="mainTiny"
          >
            {badgeText}
          </Text>
        </Box>
      ) : null}
      {!!ctaText && hasAvailableSlots ? (
        <HStack ml={4} alignItems="center">
          <Text
            maxFontSizeMultiplier={2}
            variant="mainBaseSemiBold"
            color="text-primary"
          >
            {ctaText}
          </Text>
          <Box
            ml={2}
            style={{
              width: 0,
              height: 0,
              backgroundColor: "transparent",
              borderStyle: "solid",
              borderLeftWidth: 4,
              borderRightWidth: 4,
              borderBottomWidth: 4,
              borderLeftColor: "transparent",
              borderRightColor: "transparent",
              transform: [{ rotate: "90deg" }],
            }}
            borderBottomColor="text-primary"
          />
        </HStack>
      ) : null}
    </HStack>
  );
};
